<template>
	<div id="docType-table">
		<table class="table" v-if="tableRows.length != 0 && !isLoadingDocTypes">
			<thead class="table__header">
				<tr>
					<th
						v-for="(header, index) in tableHeader"
						@click="orderByHeader(header)"
						:class="header.field == 'edit' || header.field == 'delete' ? 'icon' : ''"
						:key="index"
					>
						<div class="row">
							<span :class="header.field == 'actions' ? '' : 'pointer'">{{ header.label }}</span>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(row, index) in tableRows"
					:key="`${row.id}_${row.language}`"
					:class="[index % 2 == 0 ? 'stripped' : '', row.isInvalid ? 'invalid' : '']"
				>
					<td>{{ row.name }}</td>
					<td>{{ row.language }}</td>
					<td class="actions">
						<span @click="editRow(row)"><EditIcon :size="24" :border="'#0047ff'" /></span>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="loader" v-if="isLoadingDocTypes">
			<SpinnerIcon :color="'#597393'" />
		</div>
		<Pagination
			v-if="tableRows.length != 0 && !isLoadingDocTypes"
			:totalPages="totalPages"
			:currentFromReq="currentPage"
			@tableRequest="tableRequest"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import Pagination from '@/components/shared/Pagination/Pagination';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon';
import EditIcon from '@/components/shared/Icons/EditIcon.vue';

export default {
	name: 'Table',
	components: {
		SidebarArrow,
		Pagination,
		SpinnerIcon,
		EditIcon,
	},
	props: {
		isWeb: {
			required: true,
		},
		currentPage: {
			required: true,
		},
	},
	data: () => ({}),
	mounted() {},
	methods: {
		tableRequest(param) {
			this.$emit('changePage', param);
		},
		orderByHeader(param) {
			if (param.field == 'actions') return;
			this.$emit('orderByHeader', param.field);
		},
		editRow(row) {
			this.$router.push({
				path: '/dashboard/config/docType/detail',
				query: { id: row.id },
			});
		},
	},
	computed: {
		...mapGetters('docTypeManagement', ['docTypesList', 'isLoadingDocTypes']),
		tableHeader() {
			return [
				{
					field: 'name',
					label: 'Nome',
				},
				{
					field: 'language',
					label: 'Idioma',
				},
				{
					field: 'actions',
					label: 'Ações',
				},
			];
		},
		tableRows() {
			const rows = this.docTypesList.docTypes != undefined ? this.docTypesList.docTypes : [];

			return !rows.length ? [] : rows;
		},
		totalPages() {
			const pagination =
				this.docTypesList.totalPages != undefined ? this.docTypesList.totalPages : 1;

			return pagination;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'Table.scss';
</style>
